var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductManage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1515 2H6.84848C4.17074 2 2 4.17074 2 6.84848V17.1515C2 19.8293 4.17074 22 6.84848 22H17.1515C19.8293 22 22 19.8293 22 17.1515V6.84848C22 4.17074 19.8293 2 17.1515 2Z",
    fill: "#ADB3BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8503 16.0521C10.5709 16.0521 10.2921 15.9461 10.0788 15.7327L6.45578 12.1097C6.02972 11.6836 6.02972 10.9927 6.45578 10.5667C6.88184 10.1412 7.57275 10.1412 7.99881 10.5667L10.8503 13.4188L16.0012 8.26788C16.4279 7.84243 17.1188 7.84243 17.5443 8.26788C17.9703 8.69394 17.9703 9.38485 17.5443 9.81091L11.6218 15.7327C11.4085 15.9455 11.1297 16.0521 10.8503 16.0521Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductManage);
export default __webpack_public_path__ + "static/media/productManage.3745b623e657034513d59c872f38c3a3.svg";
export { ForwardRef as ReactComponent };